import React, { useState, useEffect } from "react";
import PostAPI from "../../APICalls/PostAPI";
import GetAPI from "../../APICalls/GetAPI";

const MenuPlanner = ({ uuID }) => {
  const [menuDays, setMenuDays] = useState([
    { date: "", bread: "", gravy: "", sabji: "", rice: "", salad: "", addOn: "" },
    { date: "", bread: "", gravy: "", sabji: "", rice: "", salad: "", addOn: "" },
    { date: "", bread: "", gravy: "", sabji: "", rice: "", salad: "", addOn: "" },
    { date: "", bread: "", gravy: "", sabji: "", rice: "", salad: "", addOn: "" },
    { date: "", bread: "", gravy: "", sabji: "", rice: "", salad: "", addOn: "" },
    { date: "", bread: "", gravy: "", sabji: "", rice: "", salad: "", addOn: "" },
    { date: "", bread: "", gravy: "", sabji: "", rice: "", salad: "", addOn: "" },
  ]);

  let corporateWeeklyMenuApi;
  let environment = process.env.REACT_APP_NODE_ENV;
  if (environment === "PRODUCTION") {
    corporateWeeklyMenuApi = process.env.REACT_APP_PROD_CORPORATEWEEKLYMENU;
  } else {
    corporateWeeklyMenuApi = process.env.REACT_APP_DEV_CORPORATEWEEKLYMENU;
  }

  useEffect(() => {
    const completeAPI = corporateWeeklyMenuApi + "?uuID=" + uuID;

    GetAPI(completeAPI)
      .then((res) => {
        if (res.data.statusCode === 200 && res.data.body.length > 0) {
          const apiData = res.data.body;
          const formattedMenuDays = apiData.map((day) => ({
            date: day.date || "",
            bread: day.bread || "",
            gravy: day.gravy || "",
            sabji: day.sabji || "",
            rice: day.rice || "",
            salad: day.salad || "",
            addon: day.addon || "",
          }));

          setMenuDays(formattedMenuDays);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  const [currentDayIndex, setCurrentDayIndex] = useState(0);

  const handleMenuChange = (field, value) => {
    const updatedMenuDays = [...menuDays];
    updatedMenuDays[currentDayIndex][field] = value;
    setMenuDays(updatedMenuDays);
  };

  const populateWeekDates = (startDate) => {
    const days = [];
    let date = new Date(startDate);

    for (let i = 0; i < 7; i++) {
      if (date.getDay() === 0) {
        date.setDate(date.getDate() + 1);
      }

      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }

    setMenuDays(
      days.map((d) => ({
        date: d.toISOString().split("T")[0],
        bread: "",
        gravy: "",
        sabji: "",
        rice: "",
        salad: "",
        addOn: "",
      }))
    );
  };

  const handleDateChange = (e) => {
    const firstDate = e.target.value;
    populateWeekDates(firstDate);
  };

  const handleNextDay = (e) => {
    e.preventDefault();
    setCurrentDayIndex((prev) => Math.min(prev + 1, menuDays.length - 1));
  };

  const handlePrevDay = (e) => {
    e.preventDefault();
    setCurrentDayIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleSaveMenu = (e) => {
    e.preventDefault();

    const menuData = {};

    menuDays.forEach((day, index) => {
      if (day.date) {
        menuData[day.date] = {
          uuID,
          bread: day.bread || "N/A",
          rice: day.rice || "N/A",
          gravy: day.gravy || "N/A",
          sabji: day.sabji || "N/A",
          salad: day.salad || "N/A",
        };
      }
    });

    PostAPI(corporateWeeklyMenuApi, menuData)
      .then((res) => {
        if (res.data.statusCode === 200) {
          alert("Successfully added menus!!");
        } else {
          console.log(res);
          alert("Failed to add menus, please try again");
        }
      })
      .catch((e) => {
        console.log(e);
        alert("Failed to add menus, please try again");
      });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Input Section */}
        <div className="col-md-6">
          <h5>Add Menu for Day {currentDayIndex + 1}</h5>
          <form>
            <div>
              <label>
                Day {currentDayIndex + 1} -{" "}
                {menuDays[currentDayIndex].date || "Select a date"}
              </label>
              <div className="form-row">
                <div className="col-md-4">
                  <input
                    type="date"
                    className="form-control"
                    value={menuDays[currentDayIndex].date}
                    onChange={(e) =>
                      currentDayIndex === 0
                        ? handleDateChange(e)
                        : handleMenuChange("date", e.target.value)
                    }
                  />
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Bread"
                    value={menuDays[currentDayIndex].bread}
                    onChange={(e) => handleMenuChange("bread", e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Gravy"
                    value={menuDays[currentDayIndex].gravy}
                    onChange={(e) => handleMenuChange("gravy", e.target.value)}
                  />
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sabji"
                    value={menuDays[currentDayIndex].sabji}
                    onChange={(e) => handleMenuChange("sabji", e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Rice"
                    value={menuDays[currentDayIndex].rice}
                    onChange={(e) => handleMenuChange("rice", e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Salad"
                    value={menuDays[currentDayIndex].salad}
                    onChange={(e) => handleMenuChange("salad", e.target.value)}
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Add On"
                    value={menuDays[currentDayIndex].addOn}
                    onChange={(e) => handleMenuChange("addOn", e.target.value)}
                  />
                </div>
              </div>
            </div>
          </form>

          {/* Navigation Buttons */}
          <div className="mt-3">
            {currentDayIndex > 0 && (
              <button
                className="btn btn-secondary mr-2"
                onClick={handlePrevDay}
              >
                Previous
              </button>
            )}
            {currentDayIndex < menuDays.length - 1 && (
              <button className="btn btn-primary" onClick={handleNextDay}>
                Next
              </button>
            )}
          </div>
        </div>

        {/* Preview Section */}
        <div className="col-md-6">
          <h5>Menu Preview</h5>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Items</th>
                  {menuDays.map((day, index) => (
                    <th key={index}>
                      Day {index + 1} <br />{day.date || "No Date"}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Bread</strong>
                  </td>
                  {menuDays.map((day, index) => (
                    <td key={index}>{day.bread || "N/A"}</td>
                  ))}
                </tr>
                <tr>
                  <td>
                    <strong>Gravy</strong>
                  </td>
                  {menuDays.map((day, index) => (
                    <td key={index}>{day.gravy || "N/A"}</td>
                  ))}
                </tr>
                <tr>
                  <td>
                    <strong>Sabji</strong>
                  </td>
                  {menuDays.map((day, index) => (
                    <td key={index}>{day.sabji || "N/A"}</td>
                  ))}
                </tr>
                <tr>
                  <td>
                    <strong>Rice</strong>
                  </td>
                  {menuDays.map((day, index) => (
                    <td key={index}>{day.rice || "N/A"}</td>
 ))}
                </tr>
                <tr>
                  <td>
                    <strong>Salad</strong>
                  </td>
                  {menuDays.map((day, index) => (
                    <td key={index}>{day.salad || "N/A"}</td>
                  ))}
                </tr>
                <tr>
                  <td>
                    <strong>Add On</strong>
                  </td>
                  {menuDays.map((day, index) => (
                    <td key={index}>{day.addOn || "N/A"}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
          <button
            className="btn btn-primary float-right"
            onClick={handleSaveMenu}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuPlanner;